// src/services/mantenimientoService.js
import axios from "../config/axiosConfig";

export const getSincronizarPlacasPreview = () =>
  axios.get("/api/mantenimiento/sincronizar-placas");

export const postSincronizarPlacasAplicar = () =>
  axios.post("/api/mantenimiento/sincronizar-placas/aplicar");
